import { getProperty } from 'customer-data-objects/objects/ObjectAccessors';
// @ts-expect-error Untyped import
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TicketTimeOpenProperty = ({
  subject
}) => {
  const createDateValue = getProperty(subject, 'createdate');
  const closeDateValue = getProperty(subject, 'closed_date');
  if (!createDateValue || closeDateValue) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    "data-test-id": "ticket-time-open",
    message: "customer-data-board-card.ticketTimeOpen",
    options: {
      amountOfTime: /*#__PURE__*/_jsx(FormattedDuration, {
        from: +createDateValue,
        type: "userTz"
      })
    }
  });
};
export default TicketTimeOpenProperty;